import { makeApiTypes } from 'sidecar-utility-library'
import reduceReducers from 'reduce-reducers'

import CheckStatusReducer from './CheckStatus'

// Export actions
export * from './CheckStatus'

export const types = {
  ...makeApiTypes('FETCH_CHECK_STATUS', 'checks'),
  SET_CHECK_STATUS_BUSY: 'checkDetails/SET_CHECK_STATUS_BUSY',
  INITIALIZE_CHECK_STATUS: 'checks/INITIALIZE_CHECK_STATUS',
}

export const initialState = {
  checkDetails: {
    busy: false,
    error: null,
    entity: {},
  },
}

export default reduceReducers(CheckStatusReducer, initialState)
